import { useEffect } from 'react';
import { useEventsContext } from './context';
import { observer } from 'mobx-react';

export interface EventsActivatorProps {
  status: 'enabled' | 'disabled';
  children: JSX.Element;
}

export const EventsActivator = observer(
  ({ status, children }: EventsActivatorProps) => {
    const { layerLoader, cardToMouseLink } = useEventsContext();

    useEffect(() => {
      if (status === 'disabled') return;

      layerLoader.show();
      cardToMouseLink.bind();
    }, []);

    if (status === 'disabled') return <></>;

    return children;
  },
);
